import React, { Component } from "react";
import { isLandscape } from "@/modules/commonMobile";
import { assetImg } from "@/modules/moduleImporter";
import { IGameResultHistoryProps, ISuwitHistoryType } from "@/types/GameHistoryTypes";

import "./index.scss";

interface IProps extends IGameResultHistoryProps {
	history: ISuwitHistoryType[];
}

export default class M19 extends Component<IProps> {
	HistoryAngka(props) {
		return (
			<div className="m19-table-cell">
				{ 
					props.angka &&
					props.angka.split(",").map((item, idx) =>
						assetImg("m19", item, "ha_" + idx, props.blink ? "sl-roadmap-alternating" : "")
					)
				}
				
			</div>
		);
	}
	
	HistoryAngkaWin(props) {
		return(
			<div className="m19-table-cell">
				{ 
					props.angkawin &&
					props.angkawin.split(",").map((item, idx) =>
						assetImg("m19", item, "haw_" + idx, props.blink ? "sl-roadmap-alternating" : "")
					)
				}
			</div>
		);
	}
		
	render() {
		const reversedHistory = this.props.history.slice(0).reverse();
		const HistoryAngka = this.HistoryAngka;
		const HistoryAngkaWin = this.HistoryAngkaWin;

		const historyBlink = this.props.historyBlink;
		
		const historyAry = (this.props.activeGameCount === 1) ?
			reversedHistory.slice(0, 6) :
			isLandscape() ?
			reversedHistory.slice(0, 5) :
			reversedHistory.slice(0, 4);
		
		return this.props.langdata ? (
			<div className="history-container m19">
			{
				this.props.activeGameCount === 1 ? [
					<div key={"max_m19_result"} className="m19-purple">
						<div className="m19-table-cell"><div>{this.props.langdata["txt_history_result"]}</div></div>
						{
							historyAry.map((data, idx) =>
								<HistoryAngka
									angka={data.angka}
									blink={historyBlink && idx === 0}
									key={"hist" + idx} />
							)
						}
					</div>,
					
					<div key={"max_m19_win"} className="m19-green">
						<div className="m19-table-cell"><div>{this.props.langdata["txt_history_win"]}</div></div>
						{
							historyAry.map((data, idx) =>
								<HistoryAngkaWin
									angkawin={data.angkawin}
									blink={historyBlink && idx === 0}
									key={"histWin" + idx} />
							)
						}
					</div>
				] : [
					<div key={"m19_result"} className="m19-grey-history">
						<div className="m19-table-cell"><div>{this.props.langdata["txt_history_result"]}</div></div>
						{
							historyAry.map((data, idx) =>
								<HistoryAngka
									angka={data.angka}
									blink={historyBlink && idx === 0}
									key={"hist" + idx} />
							)
						}
					</div>,
					
					<div key={"m19_win"} className="m19-green">
						<div className="m19-table-cell"><div>{this.props.langdata["txt_history_win"]}</div></div>
						{
							historyAry.map((data, idx) =>
								<HistoryAngkaWin
									angkawin={data.angkawin}
									blink={historyBlink && idx === 0}
									key={"histWin" + idx} />
							)
						}
					</div>
				]
			}
			</div>
		) : <div>Loading language data...</div>;
	}
}
